/* eslint-disable unicorn/no-array-reduce */
export const fonts = {
  default: 'Avenir',
  title: 'Bodoni Moda',
  alt: 'Quickpen',
};

export const colors = {
  beige: '#DBBE94',
  white: '#FFF',
  black: '#2C2C2C',
  darkBrown: '#382818',
  caramel: '#B07F51',
  grey: '#797C84',
  greyLight: '#F6F6F6',
  mauve: '#9C6B66',
};

const bp = {
  smaller: 300,
  compact: 370,
  small: 375,
  medium: 450,
  large: 750,
};

export const mq = n => {
  const bpArray = Object.keys(bp).map(key => [key, bp[key]]);

  const [result] = bpArray.reduce((acc, [name, size]) => {
    if (n === name) return [...acc, `@media (max-width: ${size}px)`];
    return acc;
  }, []);

  return result;
};
